export const PasswordLength = {
  MIN: 8,
  MAX: 255,
};

// export const PasswordRegexString = {
//   PASSWORD_REGX: `/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{${PasswordLength.MIN},}$/`
// };

export const AppGlobals = {
  // PASSWORD_REGX: `^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&amp;*()_+}{&quot;:;'?&gt;.&lt;,])[A-Za-z\d!@#$%^&amp;*()_+}{&quot;:;'?&gt;.&lt;,]{${PasswordLength.MIN},${PasswordLength.MIAx}$`
  // PASSWORD_REGX: `(?!^[0-9]{1,${PasswordLength.MAX}}$)(?!^[a-zA-Z]{1,${PasswordLength.MAX}}$)(?!^[@#$!%^&*(),.?":{}|<>]{1,${PasswordLength.MAX}}$)^([a-zA-Z0-9@#$%!^&*(),.?":{}|<>]{${PasswordLength.MIN},${PasswordLength.MAX}})$`
  // PASSWORD_REGX: `(?!^[0-9]{1,}$)(?!^[a-zA-Z]{1,}$)(?!^[@#$!%^&*(),.?":{}|<>]{1,}$)^([a-zA-Z0-9@#$%!^&*(),.?":{}|<>]{${PasswordLength.MIN},})$`
  PASSWORD_REGX: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/
  // PASSWORD_REGX: new RegExp("/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{" + PasswordLength.MIN + ",}$/")
};

// 0=Inactive, 1=Active, 2=Soft Deleted, 3=Archived
export const RecordStatus = {
  INVALID: -1,
  INACTIVE: 0,
  ACTIVE: 1,
  DELETE: 2, // Soft delete
  ARCHIVED: 3,
};

export const ScoreTrend = {
  DOWN: -1,
  NONE: 0,
  UP: 1,
};

export const ProviderIds = {
  INHERIT: -1,
  PRAISO: 0
}

export const Role = {
  DRIVER: 6,
  GUEST: 5,
  USER: 4,
  ADMIN: 3,
  SUPERADMIN: 2,
  SYSTEM: 1,
};

export const ApiStatusCodes = {
  INVALID_REQUEST_ERROR: -1,
  ERROR_NONE: 0,
  SYSTEM_ERROR: 1000,
  LOGIN_FAILED_ERROR: 1001,
  RECORD_NOT_FOUND_ERROR: 1002,
  RECORD_EXIST_ERROR: 1003,
  ACCOUNT_LOCKED_ERROR: 1004,
  ACCOUNT_LOCKED_LOGIN_FAILED_ERROR: 1005,
  SESSION_INVALID_ERROR: 2001,
  PASSWORD_CHANGE_SESSION_EXPIRED: 2002,
  PASSWORD_CHANGE_SESSION_INVALID_ERROR: 1014,
  UNAUTHORIZED_ERROR: 403,
  SESSION_EXPIRED_ERROR: 401,
  NOT_FOUND_ERROR: 404,
  PASSWORD_VALIDATION_ERROR: 3001,
  PASSWORD_CONFIRM_PASSWORD_MISMATCH_ERROR: 3002,
  RECORD_NOT_SAVED_ERROR: 1006,
  CONTENT_EXPIRED_ERROR: 1007,
  EMAIL_EXIST_ERROR: 1008,
  USER_ROLE_NOT_EXIST: 1009,
  CONTENT_ALREADY_CONSUMED_ERROR: 1010,
  ACCOUNT_DELETED_ERROR: 1011,
  DEMO_USER_ALREADY_SHADOWING: 1012,
  DEMO_USER_NOT_ACTIVE: 1013,
};

export const ContentStatus = {
  ACTIVE: 1,
  ONHOLD: 0,
  NA: -1,
};

export enum CampaignTypeEnum {
  BrakingCampaign = '1',
  CorneringCampaign = '2',
  Demonstration = '3',
  GenericMessages = '4',
  ImpactMessages = '5',
  ImprovementMessages = '6',
  InformativeMessages = '7',
  Speeding = '8',
  WelcomeMessage = '9',
  FollowOnMessages = '10',
  Carrot = '11',
  Max = '12',
  AppInstallReminderMessage = '13',
  EConsentMessage = '14',
  ContentInActivityReminderMessage = '15',
  SignedInWelcomeMessage = '16',
  PeriodicReportMessage = '17',
}

export const ContentType = {
  ANIMATION: "1",
  ARTICLE: "2",
  DRIVING_VIDEO: "3",
  EMAIL_MESSAGE: "4",
  QUIZ: "5",
};

export const DeviceOS = {
  ANDROID: "Android",
  IOS: "Ios",
  WINDOWS: "Windows",
  UNKNOWN: "Unknown",
};

export const ActionStatus = {
  ASSIGNED: 0,
  ATTEMPTED: 1,
  COMPLETED: 2,
  EXPIRED: 3,
};

export const SearchCriteria = {
  All: "0",
  Groups: "1",
  Users: "2",
};

export const IsUserAccountLocked = {
  LOCKED: 1,
  UNLOCKED: 0,
};

export const CrudAction = {
  ADD: 0,
  EDIT: 1,
  VIEW: 2,
  DELETE: 3,
};

export const UserLicenseView = {
  DEFAULT: 0,
  ALL: 1,
}

export const LicenseCheckSettingEnum = {
  NONE: -1,
  WEEEK: 0,
  MONTH: 1,
  QUARTER: 2,
  HALFYEAR: 3,
  YEAR: 4,
}

export const LicenseCheckSettingValues = {
  WEEK: "WEEKLY",
  MONTH: "MONTHLY",
  QUARTER: "QUARTERLY",
  HALFYEAR: "HALFYEARLY",
  YEAR: "YEARLY",
}

export const GroupManageBy = {
  PRAISO: 0,
  TELEMATICS: 1
};

export const GroupCode = {
  PRAISO: "PRAISO",
  OTHER_PROVIDER: "OTHER_PROVIDER"
};

export const WelcomeEmailType = {
  MANUAL: 0,
  AUTOMATIC: 1,
};

export const SortOrder = {
  NONE: 0,
  ASC: 1,
  DESC: 2,
};

export const EntityAccess = {
  NOT_ALLOWED: 0,
  ALLOWED: 1,
};

export const TokenValidityCheck = {
  YES: 1,
  No: 0,
};

export const RBAC_CODE = {
  DASHBOARD_VIEW: "DASHBOARD_VIEW",
  SCORE_CARD_VIEW: "SCORE_CARD_VIEW",
  ENGAGEMENT_CARD_VIEW: "ENGAGEMENT_CARD_VIEW",
  DRIVER_AT_RISK_CARD_VIEW: "DRIVER_AT_RISK_CARD_VIEW",
  DRIVER_AT_RISK_ACCORDION_VIEW: "DRIVER_AT_RISK_ACCORDION_VIEW",
  CE_GRAPH_VIEW: "CE_GRAPH_VIEW",
  DRIVER_STANDARD_CARD_VIEW: "DRIVER_STANDARD_CARD_VIEW",
  PENALTY_POINT_CARD_VIEW: "PENALTY_POINT_CARD_VIEW",
  WOL_VIEW: "WOL_VIEW",
  WOL_SHOW_LIMITED_USER_BUTTON_VIEW: "WOL_SHOW_LIMITED_USER_BUTTON_VIEW",
  CE_VIEW: "CE_VIEW",
  CE_SHOW_LIMITED_USER_BUTTON_VIEW: "CE_SHOW_LIMITED_USER_BUTTON_VIEW",
  CE_ACCORDION_VIEW: "CE_ACCORDION_VIEW",
  CONTENT_VIEW: "CONTENT_VIEW",
  CONTENT_PREVIEW: "CONTENT_PREVIEW",
  USER_DETAIL_VIEW: "USER_DETAIL_VIEW",
  REPORT_EVENT: "REPORT_EVENT",
  EVENT_DETAILS: "EVENT_DETAILS",
  ANALYTICS_VIEW: "ANALYTICS_VIEW",
  SCORE_TREND_CARD_VIEW: "SCORE_TREND_CARD_VIEW",
  PERFORMANCE_CARD_VIEW: "PERFORMANCE_CARD_VIEW",
  EXPORT_VIEW: "EXPORT_VIEW",
  EVENTS_VIEW: "EVENTS_VIEW",
  ADMIN_DASHBOARD_VIEW: "ADMIN_DASHBOARD_VIEW",
  ADMIN_SEARCH_BAR_VIEW: "ADMIN_SEARCH_BAR_VIEW",
  ADMIN_SEARCH_RESULT_VIEW: "ADMIN_SEARCH_RESULT_VIEW",
  ADMIN_SEARCH_RESULT_USER_VIEW: "ADMIN_SEARCH_RESULT_USER_VIEW",
  ADMIN_SEARCH_RESULT_GROUP_VIEW: "ADMIN_SEARCH_RESULT_GROUP_VIEW",
  ADMIN_USER_VIEW: "ADMIN_USER_VIEW",
  ADMIN_USER_EDIT_VIEW: "ADMIN_USER_EDIT_VIEW",
  ADMIN_USER_DELETE_VIEW: "ADMIN_USER_DELETE_VIEW",
  ADMIN_USER_CREATE_VIEW: "ADMIN_USER_CREATE_VIEW",
  ADMIN_GROUP_VIEW: "ADMIN_GROUP_VIEW",
  ADMIN_GROUP_EDIT_VIEW: "ADMIN_GROUP_EDIT_VIEW",
  ADMIN_GROUP_DELETE_VIEW: "ADMIN_GROUP_DELETE_VIEW",
  ADMIN_GROUP_CREATE_VIEW: "ADMIN_GROUP_CREATE_VIEW",
  NOTIFICATION_POPUP_VIEW: "NOTIFICATION_POPUP_VIEW",
  USER_IMPERSONATION: "USER_IMPERSONATION",
  TABLE_COMPONENT: "TABLE_COMPONENT",
  USER_TABLE_COMPONENT_MAPPING: "USER_TABLE_COMPONENT_MAPPING",
  VERIFY_EVENT: "VERIFY_EVENT",
  GET_DISTRACTION_EVENT: "GET_DISTRACTION_EVENT",
  LOCATOR_VIEW: "LOCATOR_VIEW",
  SWITCH_TRIP_VIEW: "SWITCH_TRIP_VIEW",
  UPSERT_NOTE: "UPSERT_NOTE",
  UPDATE_READ_STATUS_OF_NOTE: "UPDATE_READ_STATUS_OF_NOTE",
  MILEAGE_CLAIM: "MILEAGE_CLAIM"
};

export const TransformationType = {
  TEXT: "Text",
  IMAGE: "Image",
  BOOLEAN: "Boolean",
  ENUM: "Enum",
  ARRAY_DATA: "ArrayData",
  OBJECT_DATA: "ObjectData",
  EXCEPTION_DATA: "ExceptionData"
}

export const IsAnonymize = {
  NO: 0,
  YES: 1
};

export const IsUserNameEditable = {
  NO: 0,
  YES: 1
};

export const IsGroupNameEditable = {
  NO: 0,
  YES: 1
};

export const CacheAPI = {
  EXPIRY_TIME_MIN: 15
}

export const APICache = {
  ANALYTICS_API: "/insights/v1/analytics",
  WOL_API: "/insights/v1/wol/stats",
  CONTENT_API: "/campaign/stats",
  DASHBOARD_API: "/insights/penalty-points?4",
  SPEED_EVENT: "/insights/speed-event",
  BRAKING_EVENT: "/insights/event-details/2",
  CORNRING_EVENT: "/insights/event-details/3",
  ACCELERATION_EVENT: "/insights/event-details/19",
  MOBILE_DISTRACTION_EVENT: "/insights/event-details/20",
  DISTRACTION_EVENT: "/insights/distraction-list",
}

export const APIURL = {
  ANALYTICS_API: "insights/v1/analytics",
  DRIVER_DETAILS_API: "insights/v1/driver-details",
  DASHBOARD_COMPUTE_API: "score/v1/compute",
  WOL_STATS_API: "insights/v1/wol/stats",
  WOL_USER_LIST_API: "insights/v1/wol/",
  CONTENT_USER_LIST_API: "campaign/v1/user-list/",
  REPORT_API: "reports/v1/",
  TABLE_COMPONENT_NEW_VIEW: "user-table-component-mapping/v1/getTcView",
  TABLE_COMPONENT_CREATE_NEW_VIEW: "user-table-component-mapping/v1/create",
  TABLE_COMPONENT_UPDATE_NEW_VIEW: "user-table-component-mapping/v1/tcViewId/",
  TABLE_COMPONENT_COPY_VIEW: "user-table-component-mapping/cloneView/",
  TABLE_COMPONENT_CHANGE_VIEW: "user-table-component-mapping/v1/changeTcView",
  EVENT_MANAGEMENT_REPORT_EVENT: "reported-events", //for all reported events
  EVENT_MANAGEMENT_APPROVE_REJECT: "reported-events/", //for event details
  DRIVER_LIST_API: "insights/driver-list", //for driver list 
  TRIP_LIST_API: "insights/trip-list/", //for trip list 
  MAP_POINTS_API: "insights/map-points/", //for map points list 
  SWITCH_TRIP_API: "insights/switch-trip", //for switch trip
  GET_EVENT_WITH_ADDRESS: "trip/trip-event/",
  GET_ADMIN_MILEAGE_CLAIM: "mileage-claim/admin", // for all users mileage claim list under this admin account
  GET_MILEAGE_CLAIM_LIST: "mileage-claim",
  GET_MILEAGE_CLAIM_DETAILS: "mileage-claim",
  UPDATE_MILEAGE_CLAIM: "mileage-claim",
  GET_MILEAGE_CLAIM_DISTANCE: "trip/distance",
  CREATE_MILEAGE_CLAIM: "mileage-claim"
}

export const ReportEventEnum = {
  REPORT_EVENT: "Report Event",
  APPROVE: "Approve",
  REJECT: "Reject"
}

export const TableView = {
  SPEEDING_EVENT_USER_LIST: "SEUL",
  SPEEDING_EVENT_LIST: "SEL",
  BRAKING_EVENT_USER_LIST: "BEUL",
  BRAKING_EVENT_LIST: "BEL",
  CORNERING_EVENT_USER_LIST: "CEUL",
  CORNERING_EVENT_LIST: "CEL",
  ACCELERATION_EVENT_USER_LIST: "AEUL",
  ACCELERATION_EVENT_LIST: "AEL",
  REPORT_EVENTS: "RE",
  APPROVED_EVENTS: "ARE",
  REJECTED_EVENTS: "RRE",
  MOBILE_DISTRACTION: "MD",
  DISTRACTION_EVENT_LIST: "DEL",
  BRAKING_REPORTED_EVENTS: "BRE",
  CORNERING_REPORTED_EVENTS: "CRE",
  ACCELERATION_REPORTED_EVENTS: "ACCRE",
  DISTRACTION_REPORTED_EVENTS: "MDRE",
  BRAKING_APPROVED_EVENTS: "BARE",
  CORNERING_APPROVED_EVENTS: "CARE",
  ACCELERATION_APPROVED_EVENTS: "ACCARE",
  DISTRACTION_APPROVED_EVENTS: "MDARE",
  BRAKING_REJECTED_EVENTS: "BRRE",
  CORNERING_REJECTED_EVENTS: "CRRE",
  ACCELERATION_REJECTED_EVENTS: "ACCRRE",
  DISTRACTION_REJECTED_EVENTS: "MDRRE",
  MILEAGE_CLAIMED: 'MILEAGE_CLAIMED',
  MILEAGE_APPROVED: 'MILEAGE_APPROVED',
  MILEAGE_REJECTED: 'MILEAGE_REJECTED',
  DRIVER_MILEAGE_CLAIM_LIST: 'DRIVER_MILEAGE_CLAIM_LIST'
}

export const DragNDrop = {
  TABLE: "table",
  GROUP: "group",
  LIST: "list",
  COPY: "copy",
  EDIT: "edit",
  CREATE: "create"
}

export const TableComponentCodes = {
  WALL_OF_LEGEND: "WOL",
  CONTENT_ENGAGEMENT: "CE",
  SPEEDING_EVENT_USER_LIST: "SEUL",
  BRAKING_EVENT_USER_LIST: "BEUL",
  CORNERING_EVENT_USER_LIST: "CEUL",
  MOBILE_DISTRACTION: "MD",
  SPEEDING_EVENT_LIST: "SEL",
  BRAKING_EVENT_LIST: "BEL",
  CORNERING_EVENT_LIST: "CEL",
  DISTRACTION_EVENT_LIST: "DEL",
  REPORTED_EVENTS: "RE",
  APPROVED_REPORTED_EVENTS: "ARE",
  REJECTED_REPORTED_EVENTS: "RRE",
  USER_SEARCH_RESULTS: "USR",
  ACCELERATION_EVENT_LIST: "AEL",
  ACCELERATION_EVENT_USER_LIST: "AEUL",
  BRAKING_REPORTED_EVENTS: "BRE",
  CORNERING_REPORTED_EVENTS: "CRE",
  ACCELERATION_REPORTED_EVENTS: "ACCRE",
  DISTRACTION_REPORTED_EVENTS: "MDRE",
  BRAKING_APPROVED_EVENTS: "BARE",
  CORNERING_APPROVED_EVENTS: "CARE",
  ACCELERATION_APPROVED_EVENTS: "ACCARE",
  DISTRACTION_APPROVED_EVENTS: "MDARE",
  BRAKING_REJECTED_EVENTS: "BRRE",
  CORNERING_REJECTED_EVENTS: "CRRE",
  ACCELERATION_REJECTED_EVENTS: "ACCRRE",
  DISTRACTION_REJECTED_EVENTS: "MDRRE",
  DRIVER_MILEAGE_CLAIM_LIST: 'DRIVER_MILEAGE_CLAIM_LIST',
  MILEAGE_CLAIMED: 'MILEAGE_CLAIMED',
  MILEAGE_APPROVED: 'MILEAGE_APPROVED',
  MILEAGE_REJECTED: 'MILEAGE_REJECTED',
}

export const TableViewUpdateStatusEnum = {
  KEEP_BOTH: 1,
  REPLACE: 2
}

export const EventStatus = {
  SYSTEM_GENERATED_EVENT: 1,
  ACTUAL_EVENT: 0
}

export const ReportedEventStatus = {
  REPORTED: 1,
  APPROVED: 2,
  REJECTED: 3,
  EXPIRED: 4,
  KEEP_BOTH: 1,
  REPLACE: 2,
  NO_REPORT: 0,
  No_REPORTED_EVENT: "0",
  REPORTED_EVENT: "1",
  DISTRACTION_EVENT: 20
}

export const convertValue = {
  METER_TO_MILES: 1609,
  KMP_TO_MPH: 1.609
}

export const DriverState = {
  NONE: 0,
  MOVING: 1,
  IDLE: 2,
  PARKED: 3,
};

export const SortListBy = {
  DRIVERNAME: 1,
  DATENTIME: 2
};

export const SortListOrder = {
  NONE: 0,
  ASC: 1,
  DESC: 2,
  DATE_ASC: 3,
  DATE_DESC: 4
};

export const MapView = {
  DEFAULTVIEW: 0,
  LOCATORVIEW: 1,
  TRIPVIEW: 2,
};

export const ProviderCodes = {
  WEBFLEET: "WEBFLEET",
  COMPA: "COMPA",
  MASTERNAUT: "MASTERNAUT",
  RAC: "RAC",
  QUARTIX: "QUARTIX",
  TELETRAC: "TELETRAC",
  TTN: "TTN",
};

export const EventTypes = {
  BRAKING: 2,
  CORNERING: 3,
  SPEEDING: 4,
  ENGAGEMENT: 5,
  ACCELERATION: 19,
  DISTRACTION: 20,
  CALL_EVENT: 21,
  PHONE_USAGE_EVENT: 22,
  HARSH_BRAKING: 6,
  BRAKE_OVERUSE: 7,
  TAILGATING: 8,
  EXCESS_SPEED: 9,
  POOR_TECHNIQUE: 10,
  FAST_APPROACH: 11,
  HARSH_ACCELERATION: 23
};

export const severityLevels = {
  WARNING: 1,
  ALERT: 2,
  SEVER: 3,
  NONE: 0
};

export const speedSeverityType = {
  MOTORWAYSPEEDING: 1,
  SCHOOLRUNSPEEDING: 2,
  DRIVINGBAN: 3
}

export const TripTypeEnum = {
  PERSONAL: 0,
  BUSINESS: 1,
  NOT_DRIVING: 2,
  OTHER: 3
}

export const TripSubTypeEnum = {
  NA: 0,
  PASSENGER: 1,
  BICYCLE: 2,
  BOAT: 3,
  BUS: 4,
  FOOT: 5,
  MOTORCYCLE: 6,
  AIRPLANE: 7,
  TRAIN: 8,
  OTHER: 9
}

export const TripGernyEnum = {
  TRIP_START: 1,
  TRIP_END: 0
}

export const DriverLocatorScreenRefreshTime = {
  REFRESH_TIME: 180
}

export const ReportCode = {
  ENGAGEMENT_REPORT: 'ENGAGEMENT_REPORT',
  BILLABLE_REPORT: 'BILLABLE_REPORT'

}

export const EventCode = {
  SPEEDING: 'SPEEDING',
  BRAKING: 'BRAKING',
  CORNERING: 'CORNERING',
  DRIVER_DISTRACTION: 'DRIVER_DISTRACTION',
  ACCELERATION: 'ACCELERATION'
}

export enum ContentEngagementCategoryStatus {
  ALLDRIVERS = 0,
  DRIVERSCONTENTSENT = 1,
  DRIVERSCONTENTACTIVE = 2,
  DRIVERSVIDEOSENT = 3,
  DRIVERSVIDEOACTIVE = 4,
  SINGLE_DRIVER = 5
}

export enum CALL_EVENT {
  OUTGOING_CALL = 1,
  ANSWER_CALL = 2,
  REJECT_CALL = 3,
  END_CALL = 4,
  IN_CALL = 5
}

export enum CALL_EVENT_DESC_ENUM {
  OUTGOING_CALL = "OUTGOING_CALL",
  ANSWER_CALL = "ANSWER_CALL",
  REJECT_CALL = "REJECT_CALL",
  END_CALL = "END_CALL",
  IN_CALL = "IN_CALL",
}

export enum PHONE_USAGE_EVENT {
  CHARGER_PLUG_IN = 1,
  CHARGER_PLUG_OUT = 2,
  DEVICE_LOCK = 3,
  DEVICE_UNLOCK = 4,
  SCREEN_DISPLAY_ON = 5,
  SCREEN_DISPLAY_OFF = 6,
}

export enum PHONE_USAGE_EVENT_DESC_ENUM {
  CHARGER_PLUG_IN = "CHARGER_PLUG_IN",
  CHARGER_PLUG_OUT = "CHARGER_PLUG_OUT",
  DEVICE_LOCK = "DEVICE_LOCK",
  DEVICE_UNLOCK = "DEVICE_UNLOCK",
  SCREEN_DISPLAY_ON = "SCREEN_DISPLAY_ON",
  SCREEN_DISPLAY_OFF = "SCREEN_DISPLAY_OFF",
}

export enum LICENSE_OPERATION_STATUS_ENUM {
  LICENSE_CREATED = 0,
  CONSENT_SENT = 1,
  VALIDATED = 2,
  VALIDATED_INVALID = 3
}

export enum LicenseCheckRequestType {
  UPSERT_DRIVER = 1,
  DRIVING_LICENSE_CHECK = 2,
  DELETE_DRIVER = 3,
  ECONSENT = 4
}

export enum LicenseInsertionTypeEnum {
  MANUAL = 0,
  AUTOMATIC = 1
}

export enum MileageClaimStatusEnum {
  CLAIMED = 1,
  APPROVED = 2,
  REJECTED = 3
}